<template>
    <div class="pts ui-card">
        <div class="pts__head">
            <div class="pts__title">
                <strong>{{ suggestion.title }}</strong>
                <span class="ui-small ui-muted">{{ suggestion.ufs.join(", ") }}</span>
            </div>
            <ui-badge :tone="suggestion.travel_mode === 'flight' ? 'info' : 'teal'" :text="suggestion.travel_mode === 'flight' ? 'Avião + carro' : 'Carro'" />
        </div>
        <div class="pts__numbers">
            <span><strong>{{ suggestion.cases.length }}</strong> {{ suggestion.cases.length === 1 ? "caso" : "casos" }}</span>
            <span>{{ formatMoneyShort(suggestion.amount) }}</span>
            <span>≈ {{ suggestion.plan.days }} {{ suggestion.plan.days === 1 ? "dia" : "dias" }}</span>
            <span>≈ {{ suggestion.plan.km.toLocaleString("pt-BR") }} km de carro</span>
            <span v-if="suggestion.urgent" class="pts__urgent">{{ suggestion.urgent }} com prazo em até 20 dias</span>
        </div>
        <div class="pts__access ui-small">
            <template v-if="suggestion.travel_mode === 'flight' && best">
                <v-icon x-small>mdi-airplane</v-icon>
                {{ best.flight.from }} → {{ best.flight.to }} {{ best.flight.direct ? "direto" : `com escala em ${best.flight.via}` }} (≈ {{ formatHours(best.flight.minutes) }} de voo),
                carro a partir de {{ best.airport.city }} às {{ suggestion.plan.arrival }}.
                <span class="ui-muted">De carro desde {{ suggestion.access.office.name }} seriam ≈ {{ formatHours(suggestion.access.car.minutes) }} até {{ suggestion.access.car.to.name }}.</span>
            </template>
            <template v-else>
                <v-icon x-small>mdi-car</v-icon>
                Carro desde {{ suggestion.access.office.name }}: ≈ {{ formatHours(suggestion.access.car.minutes) }} até {{ suggestion.access.car.to.name }} ({{ suggestion.access.car.km.toLocaleString("pt-BR") }} km).
            </template>
        </div>
        <ul class="pts__cases">
            <li v-for="item in suggestion.cases.slice(0, expanded ? suggestion.cases.length : 4)" :key="item.id">
                <i class="pts__dot" :class="`pts__dot--${item.priority}`"></i>
                <router-link :to="`/prospeccao/casos/${item.id}`">{{ item.company_name }}</router-link>
                <span class="ui-muted">· {{ item.municipality.name }}<span v-if="item.deadline_due"> · prazo {{ formatFeedDate(item.deadline_due) }}</span></span>
            </li>
        </ul>
        <div class="pts__foot">
            <v-btn v-if="suggestion.cases.length > 4" x-small text @click="expanded = !expanded">{{ expanded ? "Mostrar menos" : `e mais ${suggestion.cases.length - 4}` }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="$allowed('create')" small color="primary" depressed :loading="loading" @click="$emit('use', suggestion)">{{ actionLabel }}</v-btn>
        </div>
    </div>
</template>

<script>
import { formatFeedDate, formatHours, formatMoneyShort } from "@/components/prospect/prospect.util";

// Cartao de um roteiro sugerido (grupo de casos por regiao com o jeito de chegar).
export default {
    name: "ProspectTripSuggestion",

    props: {
        suggestion: { type: Object, required: true },
        actionLabel: { type: String, default: "Criar roteiro" },
        loading: { type: Boolean, default: false },
    },

    data: () => ({ expanded: false }),

    computed: {
        best() {
            return this.suggestion.access && this.suggestion.access.flights ? this.suggestion.access.flights[0] : null;
        },
    },

    methods: {
        formatFeedDate,
        formatHours,
        formatMoneyShort,
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/ui/tokens";

.pts {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0 !important;
    gap: 8px;
    padding: 14px 16px;
    font-size: 13px;
}

.pts__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
}

.pts__title {
    display: flex;
    flex-direction: column;
    min-width: 0;

    strong {
        font-size: 14px;
    }
}

.pts__numbers {
    display: flex;
    flex-wrap: wrap;
    gap: 2px 12px;
}

.pts__urgent {
    color: #b45309;
}

.pts__access {
    line-height: 1.5;
}

.pts__cases {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        padding: 2px 0;
    }
}

.pts__dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 6px;
    border-radius: 50%;
    background: #94a3b8;
}

.pts__dot--alta {
    background: #b91c1c;
}

.pts__dot--media {
    background: #7857a8;
}

.pts__foot {
    display: flex;
    align-items: center;
    margin-top: auto;
}
</style>
